
function initLampInfoCanvasAnimation() {
  const canvas = document.querySelector('.js-lamp-info-canvas');
  if (!canvas) {
    return;
  }

  const context = canvas.getContext('2d');
  if (!context) {
    return;
  }

  context.imageSmoothingEnabled = true;
  context.imageSmoothingQuality = 'high';

  const frameCount = 59;
  const framePad = parseInt(canvas.dataset.framePad, 10) || 2;

  const desktopFrameTemplate = canvas.dataset.frameSrcDesktop;
  const mobileFrameTemplate = canvas.dataset.frameSrcMobile;
  const frameTemplate = window.isMobile ? mobileFrameTemplate : desktopFrameTemplate;
  const images = [];
  const loaded = {};
  const imageSeq = { frame: 1 };

  function getFrameSrc(index) {
    const frame = String(index).padStart(framePad, '0');
    if (frameTemplate.includes('{frame}') || frameTemplate.includes('{index}')) {
      return frameTemplate
        .replace(/\{frame\}/g, frame)
        .replace(/\{index\}/g, String(index));
    }

    return `${frameTemplate}${frame}`;
  }

  function getLoadedImage(index) {
    if (Object.keys(loaded).length !== frameCount) {
      return null;
    }
    return images[index];
  }

  function render() {
    console.log(`Rendering frame ${Math.round(imageSeq.frame)}`);
    const img = getLoadedImage(Math.round(imageSeq.frame) - 1);
    if (!img) {
      return;
    }

    const width = canvas.clientWidth;
    const height = canvas.clientHeight;
    context.clearRect(0, 0, width, height);

    const scale = Math.min(width / img.width, height / img.height);
    const drawWidth = img.width * scale;
    const drawHeight = img.height * scale;
    const x = (width - drawWidth) / 2;
    const y = (height - drawHeight) / 2;

    context.drawImage(img, x, y, drawWidth, drawHeight);
  }

  for (let i = 1; i <= frameCount; i++) {
    const img = new Image();
    img.decoding = 'async';
    img.src = getFrameSrc(i);
    images.push(img);

    img.onload = () => {
      loaded[i - 1] = true;
      render();
    };
  }

  let length = Math.round(window.innerWidth * 600 / 1920);
  if (window.isMobile) {
    length = 350;
  }
  const lampInfoScrollTrigger = {
    trigger: '.lamp-info__wrapper',
    start: window.isMobile ? 'bottom bottom+=100' : 'bottom bottom+=250',
    end: '+=' + length,
    scrub: true,
    // invalidateOnRefresh: true,
  };

  gsap.to(imageSeq, {
    frame: frameCount,
    snap: 'frame',
    ease: 'none',
    onUpdate: render,
    scrollTrigger: { ...lampInfoScrollTrigger },
  });

  function resizeCanvas() {
    const dpr = window.devicePixelRatio || 1;
    const cssWidth = canvas.clientWidth;
    const cssHeight = canvas.clientHeight;
    canvas.width = cssWidth * dpr;
    canvas.height = cssHeight * dpr;
    context.setTransform(1, 0, 0, 1, 0, 0);
    context.scale(dpr, dpr);
    render();
  }

  window.addEventListener('resize', resizeCanvas);
  resizeCanvas();
}

function initAnimation() {
  initLampInfoCanvasAnimation();

  const pin = ScrollTrigger.create({
    trigger: '.js-lamp-pin',
    start: isMobile ? 'top 15px' : 'top 30px',
    end: '+=600',
    pin: '.js-lamp',
  });

  let height = window.innerHeight;
  gsap.fromTo('.lamp', {
    scale: 1.05
  }, {
    scale: 1,
    scrollTrigger: {
      trigger: '.js-lamp',
      start: 'top bottom',
      scrub: true,
      end: '+=' + height,
    }
  });

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: '.js-lamp',
      start: isMobile ? 'top 15px' : 'top 30px',
      end: '+=350',
      scrub: true,
    }
  });

  tl.fromTo('.js-first-text',
    { opacity: 1 },
    { opacity: 0, duration: 0.3, ease: 'none' }
  );

  tl.fromTo('.js-second-text',
    { opacity: 0 },
    { opacity: 1, duration: 0.6, ease: 'none' },
  );


  gsap.fromTo('.lamp__img--2', {
    opacity: 0,
  }, {
    opacity: 1,
    scrollTrigger: {
      trigger: '.js-lamp',
      start: isMobile ? 'top 15px' : 'top 30px',
      end: '+=350',
      scrub: true
    }
  });
}

document.addEventListener('DOMContentLoaded', initAnimation);
